import React from 'react';
import styled from 'styled-components';
import { Border, Color, Grid } from '../app/StyleGuide';

export const ProgressBar = styled.div<{
  progress: number;
  trackColor: string;
  fillColor: string;
}>`
  background: ${props => props.trackColor};
  padding: 0;
  margin: 0;
  height: ${Grid._3};
  position: relative;
  border-radius: ${Border.radius};
  :before {
    background: ${props => props.fillColor};
    display: inline-block;
    content: '';
    top: 0;
    left: 0;
    height: ${Grid._3};
    width: ${props => props.progress}%;
    position: absolute;
    border-radius: ${Border.radius};
    transition: width 0.3s ease;
  }
`;

export const PathwayProgressBar = ({ progress }: { progress: number }) => (
  <ProgressBar className="wf-progress-bar" progress={progress} trackColor={Color.Blue._10} fillColor={Color.Blue._50} />
);

export const CourseProgressBar = ({ progress }: { progress: number }) => (
  <ProgressBar
    className="tl-progress-bar"
    progress={progress}
    trackColor={Color.Green._10}
    fillColor={Color.Green._50}
  />
);
